// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const events = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_EVENT':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_EVENT':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_EVENT':
      return { ...state }
    case 'EDIT_EVENT':
      return { ...state }
    case 'DELETE_EVENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default events
